import { requestGet, requestPost } from '@/utils/request';

const api = {
    LIST: '/system/config_list',
    UPDATE: '/system/config_update',
}

export async function configList() {
    return requestGet(api.LIST);
}

export async function configUpdate(form) {
    return requestPost(api.UPDATE, form);
}